import { Component } from "react";

import { requestFrontendReload } from "../../util/vitePreloadRecovery";

export default class AppErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("[AppErrorBoundary] Falha ao renderizar a aplicação", {
      error,
      componentStack: errorInfo?.componentStack,
    });

    requestFrontendReload();
  }

  render() {
    if (!this.state.error) return this.props.children;

    // O erro continua sendo registrado no console, mas a recuperação não exige
    // intervenção: a aplicação recarrega sozinha com proteção contra rajadas.
    return null;
  }
}
